import React, { useState } from 'react';

type Event = {
  id: number;
  event_Name: string;
  start_Datetime: string;
  end_Datetime: string;
  event_Img?: string;
  description: string;
  status: string;
  submitted_By?: string;
  submitted_Email?: string;
  created_At?: string;
};

interface DeleteEventModalProps {
  event: Event | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (eventId: number) => void;
}

const DeleteEventModal: React.FC<DeleteEventModalProps> = ({ event, isOpen, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen || !event) return null;

  const handleDelete = async () => {
    setLoading(true);
    try {
      onConfirm(event.id);
      onClose();
    } catch (err) {
      console.error(err);
      // You could add error handling here if needed
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-modal-backdrop">
      <div className="dashboard-modal dashboard-modal-delete-confirm">
        <button 
          className="dashboard-modal-close" 
          aria-label="Close" 
          onClick={onClose}
          disabled={loading}
        >
          &times;
        </button>
        <div className="dashboard-modal-delete-x">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="28" r="26" stroke="#e74c3c" strokeWidth="3" fill="none" />
            <path d="M19 19l18 18M37 19l-18 18" stroke="#e74c3c" strokeWidth="3" strokeLinecap="round" />
          </svg>
        </div>
        <div className="dashboard-modal-delete-title">Are you sure?</div>
        <div className="dashboard-modal-delete-msg">
          <div className="dashboard-modal-delete-details">
            <b>Title:</b> {event.event_Name}
          </div>
          <div className="dashboard-modal-delete-details">
            <b>Date:</b> {new Date(event.start_Datetime).toLocaleDateString()} - {new Date(event.end_Datetime).toLocaleTimeString()}
          </div>
        </div>
        <div className="dashboard-modal-actions dashboard-modal-delete-actions">
          <button 
            className="dashboard-modal-cancel" 
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            className="dashboard-modal-save dashboard-modal-delete-btn" 
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteEventModal; 